<template>
  <b-input-group 
    :prepend="label" 
    :class="containerClass">
    <b-form-select 
      :value="effectiveValue" 
      :options="options" 
      :size="size" 
      @input="handleInput" />
    <b-input-group-append v-if="showInfo">
      <b-button 
        v-b-tooltip.hover
        variant="outline-secondary" 
        size="sm" 
        :title="tooltipText">
        <i class="fa fa-info-circle" />
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
export default {
    name: 'ConditieLimit',
    props: {
        value: {
            type: [Number, null],
            default: null
        },
        label: {
            type: String,
            default: 'Max conditie'
        },
        containerClass: {
            type: String,
            default: 'mx-2'
        },
        size: {
            type: String,
            default: 'md'
        },
        showGlobalOption: {
            type: Boolean,
            default: false
        },
        showInfo: {
            type: Boolean,
            default: false
        },
        scope: {
            type: String,
            default: 'global' // 'global' or 'onderdeel'
        }
    },
    computed: {
        effectiveValue() {
            return this.value !== undefined ? this.value : null;
        },

        options() {
            const baseOptions = [
                { value: 3, text: 'Maximaal 3 (Geel)' },
                { value: 4, text: 'Maximaal 4 (Oranje)' },
                { value: 5, text: 'Maximaal 5 (Rood)' }
            ];

            if (this.showGlobalOption) {
                return [
                    { value: null, text: 'Gebruik globale instelling' },
                    ...baseOptions,
                    { value: 6, text: 'Geen limiet' }
                ];
            }

            return [
                { value: null, text: 'Geen limiet' },
                ...baseOptions
            ];
        },

        tooltipText() {
            return this.scope === 'global'
                ? 'Limiet wordt alleen toegepast op acties, niet op gebreken'
                : 'Override voor dit onderdeel. Laat leeg voor globale instelling.';
        }
    },

    methods: {
        handleInput(newValue) {
            this.$emit('input', newValue);
        }
    }
}
</script>